"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateEffect = void 0;
const react_1 = require("react");
const useUpdateEffect = (effect, deps) => {
    const isFirstRender = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        return effect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
exports.useUpdateEffect = useUpdateEffect;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlVXBkYXRlRWZmZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL3VzZVVwZGF0ZUVmZmVjdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpQ0FBMEU7QUFFbkUsTUFBTSxlQUFlLEdBQUcsQ0FDN0IsTUFBc0IsRUFDdEIsSUFBcUIsRUFDckIsRUFBRTtJQUNGLE1BQU0sYUFBYSxHQUFHLElBQUEsY0FBTSxFQUFVLElBQUksQ0FBQyxDQUFDO0lBRTVDLElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDYixJQUFJLGFBQWEsQ0FBQyxPQUFPLEVBQUUsQ0FBQztZQUMxQixhQUFhLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQztZQUM5QixPQUFPO1FBQ1QsQ0FBQztRQUVELE9BQU8sTUFBTSxFQUFFLENBQUM7UUFDaEIsdURBQXVEO0lBQ3pELENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQztBQUNYLENBQUMsQ0FBQztBQWZXLFFBQUEsZUFBZSxtQkFlMUIifQ==